import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Emails com acesso à área de super-admin (encomendas recorrentes)
export const SUPER_ADMIN_EMAILS = [
  'gustavo.vieira@hendrios.agency',
];

export function isSuperAdmin(user) {
  return user && SUPER_ADMIN_EMAILS.includes(user.email?.toLowerCase());
}

/**
 * Guarda de rota que só permite os emails da lista SUPER_ADMIN_EMAILS.
 * Qualquer outro utilizador é redirecionado para /dashboard.
 */
const SuperAdminRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return null;

  if (!isAuthenticated) return <Navigate to="/" replace />;

  if (!isSuperAdmin(user)) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
};

export default SuperAdminRoute;
